import AddCustomerGraphic from "@assets/svg/AddCustomerGraphic";
import AddUserIcon from "@assets/svg/AddUserIcon";
import AddUserWhite from "@assets/svg/AddUserWhite";
import Text from "@components/AppText";
import SearchBar from "@components/SearchBar";
import { CUSTOMER_PAGE } from "@constants/analyticsEventsCT";
import colors from "@constants/color";
import t from "@constants/localization";
import metrics from "@constants/metrics";
import useLeaderState from "@hooks/useLeaderState";
import analytics from "@services/analytics";
import {
  getAllCohorts,
  getAllLeaderCustomers,
  toggleCMAddCustomer,
} from "@services/api";
import { useDebounce } from "@utils/debounce";
import React, { useEffect, useRef, useState } from "react";
import {
  FlatList,
  RefreshControl,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { useSelector } from "react-redux";
import HomeSearch from "../Home/Header";
import { CustomerListItem } from "./CustomerListItem";
import CustomersFromCMO from "./CustomersFromCMO";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";

const PATH = "screens/YourStore/CustomerList";

const CustomerList = (props) => {
  const { navigation = {}, route = {} } = props;
  const { user } = useSelector(({ auth }) => auth);

  const offset = useRef(0);
  const limit = useRef(10);

  const loadingRef = useRef(false);

  const is_suspended =
    user?.is_suspended || user?.leader_state === "LEADER_SUSPENDED";

  const [searchQuery, setSearchQuery] = useState();
  const [cmoAddCustomer, setCmoAddCustomer] = useState();
  const [cmoAddCustomerEnabledModal, setCmoAddCustomerEnabledModal] =
    useState();
  const [isLoading, setIsLoading] = useState(false);
  const [customerList, setCustomerList] = useState({});
  const [cohorts, setCohorts] = useState([]);
  const [changed, setChanged] = useState(true);
  const [isClSuspended, setClSunpended] = useState(is_suspended || false);
  const { canLeaderUseApp } = useLeaderState();
  const debounceSearchTerm = useDebounce(searchQuery, 300);

  useEffect(() => {
    const willFocusSubscription = navigation.addListener("focus", () => {
      offset.current = 0;
      getAllCohorts()
        .then((response) => setCohorts(response.data))
        .catch((e) => {
          console.log(e);
        });
      getAllCustomer();
    });
    return willFocusSubscription;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation]);

  useEffect(() => {
    if (user.serviceability_radius !== -1) {
      setCmoAddCustomer(true);
    }
  }, [user]);
  useEffect(() => {
    setChanged(!changed);
  }, [customerList]);

  useEffect(() => {
    offset.current = 0;
    getAllCustomer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceSearchTerm]);

  const getAllCustomer = (type = null) => {
    if (!type) {
      setIsLoading(true);
    }
    getAllLeaderCustomers({
      limit: limit.current,
      offset: offset.current,
      query: searchQuery && searchQuery.length > 0 ? searchQuery : "",
      cohortId: "",
    })
      .then((response) => {
        setIsLoading(false);
        loadingRef.current = false;

        if (type === "onscroll") {
          setCustomerList({
            ...response.data,
            data: [...customerList.data, ...response.data.data],
          });
        } else {
          setCustomerList(response.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log("##", error);
      });
  };

  const onScrollCustomerList = (e) => {
    const { nativeEvent } = e;
    if (
      isCloseToBottom(nativeEvent) &&
      customerList &&
      Array.isArray(customerList.data) &&
      customerList.data.length >= 10 &&
      customerList.count > offset.current &&
      !loadingRef.current
    ) {
      console.log("on End Reach");
      offset.current += limit.current;
      loadingRef.current = true;
      getAllCustomer("onscroll");
    }
  };

  const isCloseToBottom = ({
    layoutMeasurement,
    contentOffset,
    contentSize,
  }) => {
    const paddingToBottom = 20;
    return (
      layoutMeasurement.height + contentOffset.y >=
      contentSize.height - paddingToBottom
    );
  };

  const toggleCanCMAddCustomerSwitch = async () => {
    try {
      await toggleCMAddCustomer(!cmoAddCustomer ? 500 : -1);

      if (!cmoAddCustomer) {
        analytics.trackEvent(CUSTOMER_PAGE.CMO_ENABLED);
      } else {
        analytics.trackEvent(CUSTOMER_PAGE.CMO_DISABLED);
      }

      setCmoAddCustomer((previousState) => {
        if (!previousState === true) {
          setCmoAddCustomerEnabledModal(true);
        }
        return !previousState;
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleAddCustomer = () => {
    if (!canLeaderUseApp()) {
      return;
    }
    analytics.trackEvent(CUSTOMER_PAGE.CX_PAGE_CX_ADD);
    navigation.navigate("Customer", { fromCustomer: true });
  };

  const handleCustomerSegmentCard = (cohort) => {
    analytics.trackEvent(CUSTOMER_PAGE.CX_PAGE_BANNER_CLICKED, {
      screenName: cohort.title,
    });
    if (isClSuspended) return;
    navigation.navigate("CustomerSegmentList", {
      cohort_id: cohort.id,
    });
  };

  const handleCustomer = (customer) => {
    analytics.trackEvent(CUSTOMER_PAGE.CX_PAGE_NAME_CLICKED, {
      cx_id: customer.user_id,
    });
    if (isClSuspended) return;
    navigation.navigate("CustomerProfile", {
      user: customer,
      fetchProfile: true,
    });
  };

  const _renderListHeader = () => {
    return (
      <View style={styles.customerSegmentContainer}>
        <Text
          fontType="head1"
          disabled={isClSuspended}
          style={[
            styles.headerText,
            {
              marginTop: 10,
            },
          ]}
        >
          {t(`${PATH}/KYC`)}
        </Text>
      </View>
    );
  };

  const _renderEmptyComponent = () => {
    return (
      <View style={styles.emptyContainer}>
        <AddCustomerGraphic />
        <Text
          fontType="content1"
          style={{ textAlign: "center", marginTop: 10 }}
        >
          {t(`${PATH}/noCustomerAdded`)}
        </Text>

        <TouchableOpacity
          onPress={handleAddCustomer}
          style={[
            styles.addButtonContainer,
            isClSuspended ? { backgroundColor: "rgba(0, 0, 0, 0.35)" } : {},
          ]}
          disabled={isClSuspended}
        >
          <AddUserWhite />
          <Text
            bold
            fontType="content1"
            style={{ color: colors.white, marginLeft: 10 }}
          >
            {t(`${PATH}/addCustomer`)}
          </Text>
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <HeaderWithBackAndTitle
        headertitle={t(`${PATH}/KYC`)}
        headerColor="#fff"
        hideShadow={true}
        navigation={navigation}
        route={route}
      />
      {cohorts &&
        cohorts.length > 0 &&
        cohorts.every((cohort) => parseInt(cohort.num_cx, 10) === 0) && (
          <View style={styles.container}>{_renderEmptyComponent()}</View>
        )}
      {cohorts &&
        cohorts.length > 0 &&
        cohorts.some((cohort) => parseInt(cohort.num_cx, 10) !== 0) && (
          <>
            <SearchBar
              clearSearch
              customStyles={styles.searchContainer}
              query={searchQuery}
              placeholder={t(`${PATH}/searchCustomer`)}
              shouldShowIcon
              handleQueryChange={(value) => setSearchQuery(value)}
              onPressRightIcon={() => setSearchQuery("")}
            />
            <FlatList
              extraData={changed}
              data={customerList.data}
              keyExtractor={(item) => item.user_id}
              showsVerticalScrollIndicator={false}
              renderItem={({ item }) => (
                <CustomerListItem
                  isNew={item.is_new}
                  cx_trend={item.cx_trend}
                  connectedByCm={item.is_connected_by_cm}
                  onPress={() => handleCustomer(item)}
                  leader={user.name}
                  name={item.user_name}
                  mobile={item.user_phone}
                  appShare={item.app_share_link}
                  user_id={item.user_id}
                  isClSuspended={isClSuspended}
                />
              )}
              initialNumToRender={20}
              onEndReachedThreshold={0.9}
              onScroll={onScrollCustomerList}
              contentContainerStyle={styles.listContentContainer}
              refreshControl={
                <RefreshControl
                  style={styles.refreshControl}
                  refreshing={isLoading}
                  onRefresh={() => {
                    offset.current = 0;
                    getAllCustomer();
                  }}
                  colors={[colors.primary]}
                />
              }
            />
          </>
        )}
      <CustomersFromCMO
        onClose={() => setCmoAddCustomerEnabledModal(false)}
        visible={cmoAddCustomerEnabledModal}
      />
    </View>
  );
};
export default CustomerList;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.primaryBg,
  },
  emptyContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    maxHeight: "100%",
  },
  addCustomerButton: {
    backgroundColor: "rgba(0,0,0,0.1)",
    borderRadius: 100,
    height: 40,
    width: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  searchContainer: {
    padding: metrics.baseGutter,
    backgroundColor: "#fff",
    bottom: 15,
    // padding: ,
  },
  customerSegmentContainer: {
    // margin: metrics.baseGutter,
    marginBottom: metrics.baseGutter - 10,
  },
  headerText: {
    marginTop: metrics.baseGutter + 5,
    marginHorizontal: metrics.baseGutter,
    marginBottom: metrics.baseGutter - 5,
    fontFamily: "NotoSansDevanagari-Bold",
  },
  refreshControl: {
    position: "absolute",
    top: 0,
    zIndex: 99,
  },
  listContentContainer: {
    paddingBottom: 100,
  },
  addButtonContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
    backgroundColor: colors.primary,
    width: metrics.screenWidth * 0.9,
    height: 50,
    borderRadius: 10,
    marginTop: 20,
  },
});
